<template>
  <!-- 遮罩层背景 -->
  <teleport to="body">
    <div v-if="hasBackground" v-show="visible" class="popup-overlay-background">
      <slot name="background"></slot>
    </div>
  </teleport>
  
  <!-- 弹窗盒子 -->
  <van-popup
    v-model:show="visible"
    class="fullscreen-popup"
    :position="position"
    :close-on-click-overlay="closeOnClickOverlay"
    :overlay-style="resolvedOverlayStyle"
    teleport="body"
    @close="handlePopupClosed"
  >
    <div class="popup-view" :style="popupStyle">
      <slot name="content"></slot>
      <div v-if="closeable" class="close-icon-box" @click="close">
        <van-icon name="cross" size="24" color="#FFFFFF" />
      </div>
    </div>
  </van-popup>
</template>

<script setup>
const visible = ref(false)
const slots = useSlots()
const props = defineProps({
  height: { type: [Number, String], default: 100 },
  closeOnClickOverlay: { type: Boolean, default: false },
  position: { type: String, default: 'center' },
  closeable: { type: Boolean, default: false },
  overlayStyle: { type: Object, default: null },
})

const hasBackground = computed(() => !!slots.background?.())

const resolvedOverlayStyle = computed(() => {
  if (props.overlayStyle) return props.overlayStyle
  if (hasBackground.value) return { background: 'transparent' }
  return undefined
})

const popupStyle = computed(() => {
  const obj = {
    height: !isNaN(props.height) ? `${props.height}vh` : `${props.height}`,
  }

  return obj
})

const emit = defineEmits(['close'])

const open = () => {
  visible.value = true
}

/** 仅关闭弹窗；由 van-popup @close 统一向上 emit，避免重复触发 */
const close = () => {
  if (!visible.value) return
  visible.value = false
}

/** van-popup 真正关闭后回调（只触发一次） */
const handlePopupClosed = () => {
  emit('close')
}

defineExpose({ open, close })
</script>

<style scoped lang="less">
.popup-overlay-background {
  position: fixed;
  inset: 0;
  z-index: var(--van-overlay-z-index, 2000);
  overflow: hidden;
  pointer-events: none;
}
.popup-view {
  position: relative;
  width: 100vw;
  overflow: visible;

  .close-icon-box {
    position: fixed;
    top: 40px;
    right: 20px;
  }
}
</style>

<!-- teleport 到 body 后 scoped 无法稳定命中 van-popup 根节点，需非 scoped -->
<style lang="less">
.fullscreen-popup.van-popup {
  overflow: visible;
}

.fullscreen-popup.van-popup--center {
  padding: 0;
  width: 100vw;
  height: 100vh;
  max-width: 100vw;
  max-height: 100vh;
  border-radius: 0;
}
</style>
